module.exports = __webpack_public_path__ + "static/media/crew-marie.294aa618.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightPage/img/crew-marie.png
// module id = 366
// module chunks = 0